
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-development",
      function () {
        return require("private-next-pages/mobile-development/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-development"])
      });
    }
  